<template>
  <div>
    <pre v-if="isMagnoliaEdit" class="editmode-info-box">{{ code }}</pre>
    <div v-else v-html="code"></div>
  </div>
</template>

<script>
export default {
  name: "CodeComponent",
  props: ["code"],
};
</script>

<script setup>
const { isMagnoliaEdit } = useMagnoliaContext();
</script>
